<template>
    <div>
        <h1 class="text-center">Mes Salons</h1>
        <v-row justify="center">
          <v-col cols="11">
            <Table></Table>    
          </v-col>
        </v-row>
    </div>
</template>

<script>
import Table from './rooms/Table'

export default {
    name: 'RoomsPage',
    components: {
        Table
    }
}
</script>
